<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div :class="panelMode ? 'p-3' :'container mt-4 mb-4'">
    <div class="mt-2" style="max-width:597px">
        <h3>Legg til valg i gruppen "{{addOnGroup.name}}"</h3>

        <div v-if="addOnTemplates.length > 0" class="mt-4">
          <span class="ingredient-title">Velg fra tilbehørsbiblioteket (valgfritt)</span>
          <select class="form-select" v-model="addOn.templateId" @change="onTemplateSelected">
            <option value="">Fritekst (ikke fra biblioteket)</option>
            <option v-for="addOnTemplate in addOnTemplates" :key="addOnTemplate.id" :value="addOnTemplate.id">{{ addOnTemplate.name }}</option>
          </select>
          <div v-if="isFromLibrary" class="text-muted mt-1">
            Navn og pris styres av biblioteket, og oppdateres automatisk i alle gruppene som bruker valget.
          </div>
        </div>

        <div class="mt-5">
          <span class="ingredient-title">Navn</span>
          <input class="form-control" type="text" v-model="addOn.name" :disabled="isFromLibrary"/>
        </div>

        <div class="ingredient-title mt-4">Pris</div>
        <div class="row mt-2">
            <div class="mt-3"><strong> Ta med/takeaway </strong></div>
            <div class="col-sm-6 d-inline-block">
              <input class="form-control" type="number" min="0" v-model="price" @input="updatePriceWithVat()" :disabled="isFromLibrary"/>
              <span class="ms-2">(uten MVA)</span>
            </div>
            <div class="col-sm-6 d-inline-block">
              <input class="form-control" type="number" min="0" v-model="priceWithVat" @input="updatePrice()" :disabled="isFromLibrary"/>
              <span class="ms-2">
                (med MVA for TAKEAWAY, {{ vat.takeOut }}%)
              </span>
            </div>
        </div>
        <div v-if="useFunctionality === 'POS' || useFunctionality === 'KIOSK_TAKEAWAY' || useFunctionality === 'ALL'" class="row mt-2">
            <div class="mt-3"><strong> Spise her </strong></div>
            <div class="col-sm-6 d-inline-block">
              <input class="form-control" type="number" min="0" v-model="priceDineIn" @input="updatePriceDineInWithVat()" :disabled="isFromLibrary"/>
              <span class="ms-2">(uten MVA)</span>
            </div>
            <div class="col-sm-6 d-inline-block">
                <input class="form-control" type="number" min="0" v-model="priceDineInWithVat" @input="updatePriceDineIn()" :disabled="isFromLibrary"/>
                <span class="ms-2">
                      (med MVA for SPISE HER, {{ vat.dineIn }}%)
                </span>
            </div>
            <div v-if="dineInPriceSuggestion" class="mt-1">
              <a href="#" class="bo_suggestion-btn" @click.prevent="applyDineInPriceSuggestion">
                Klikk for å bruke samme grunnpris som ta med: kr {{ dineInPriceSuggestion }} uten mva = kr {{ dineInPriceSuggestionWithVat }} med {{ vat.dineIn }}% mva
              </a>
            </div>
        </div>

        <div v-if="addOnAllowMultipleTimes" :class="addOn.allowMultipleTimes ? 'form-control' : ''">
          <div class="form-switch-wrapper mt-2 mb-3">
            <label class="form-switch">
              <div class="form-switch-container">
                <span class="bold me-2">Tillatt å velge flere ganger</span>
                <input type="checkbox" v-model="addOn.allowMultipleTimes" />
                <i></i>
              </div>
            </label>
          </div>
          <div v-if="addOn.allowMultipleTimes" class="col-sm-8">
              <div class="col-sm-8">Maksimalt tillatt antall</div>
              <input type="number" min="2" max="100" v-model="addOn.maximum" />
          </div>
        </div>

        <div class="bo_hr mt-4">
          <hr/>
        </div>

        <div class="mb-5">
          <button v-if="activateSaveButton" type="button" class="bo_btn" @click="saveAddOn"> Lagre </button>
          <button v-else type="button" class="bo_btn" @click="saveAddOn" disabled="true"> Lagre </button>
        </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import MerchantUtil from "@/util/MerchantUtil";
import ProductService from "@/services/product/ProductService";
import ItemUtil from "@/util/ItemUtil";

export default {
  components: {LoadingSpinner},
  props: {
    panelMode: { type: Boolean, default: false },
    addOnGroupIdProp: { type: String, default: '' }
  },
  emits: ['saved'],
  data() {
    return {
      loading: false,

      addOnGroup: {},
      vat: {},
      addOnTemplates: [],

      price: 0,               //Takeaway price without VAT
      priceWithVat: "",       //Takeaway price with VAT
      priceDineIn: 0,         //Dine-in price without VAT
      priceDineInWithVat: "", //Dine-in price with VAT

      addOn: {
        type: "add-on",
        merchant: "",
        addOnGroupId: "",
        name: "",
        price: 0,
        priceDineIn: 0,
        allowMultipleTimes: false,
        maximum: 100,
        sortOrder: -1,
        templateId: ""
      }
    };
  },
  mounted() {
    this.addOn.addOnGroupId = this.addOnGroupIdProp || this.$route.query.addOnGroupId;
    Promise.all([
      ProductService.getDataForAddOnAdminGui(this.addOn.addOnGroupId),
      ProductService.getAddOnTemplates()
    ]).then(
        ([guiResponse, templatesResponse]) => {
          let dataForGui = guiResponse.data;
          this.addOnGroup = dataForGui.addOnGroup;
          this.vat = dataForGui.vat;
          this.addOn.merchant = this.addOnGroup.merchant;
          this.addOnTemplates = templatesResponse.data;

          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
    );
  },
  computed: {
    useFunctionality(){
      return MerchantUtil.useFunctionality();
    },
    activateSaveButton(){
      if(this.addOn.name.length > 0){
        return true;
      } else {
        return false;
      }
    },
    addOnAllowMultipleTimes(){
      return MerchantUtil.addOnAllowMultipleTimes();
    },
    isFromLibrary(){
      return this.addOn.templateId.length > 0;
    },
    dineInPriceSuggestion(){
      //Suggest the same base price as takeaway, the gross price differs because of the VAT difference
      if(this.isFromLibrary || this.price === "" || Number(this.price) <= 0){
        return null;
      }
      if(Number(this.price) === Number(this.priceDineIn)){
        return null; //Already the same base price
      }
      return Number(this.price);
    },
    dineInPriceSuggestionWithVat(){
      return ItemUtil.getPriceDineIn(this.dineInPriceSuggestion || 0, this.vat);
    }
  },
  methods: {
    onTemplateSelected(){
      if(this.isFromLibrary){
        let addOnTemplate = this.addOnTemplates.find(template => template.id === this.addOn.templateId);
        if(addOnTemplate){
          this.addOn.name = addOnTemplate.name;
          this.addOn.itemId = addOnTemplate.itemId || "";
          this.price = addOnTemplate.price;
          this.priceDineIn = addOnTemplate.priceDineIn;
          this.updatePriceWithVat();
          this.updatePriceDineInWithVat();
        }
      } else {
        this.addOn.itemId = "";
      }
    },
    updatePriceWithVat(){
      let priceWithVat = this.price + (this.price / 100 * this.vat.takeOut);
      this.priceWithVat = Math.round(priceWithVat);
    },
    updatePriceDineInWithVat(){
      let priceDineInWithVat = this.priceDineIn + (this.priceDineIn / 100 * this.vat.dineIn);
      this.priceDineInWithVat = Math.round(priceDineInWithVat);
    },
    updatePrice(){
      this.price = ItemUtil.getPriceWithoutVat(this.vat.takeOut, this.priceWithVat);
    },
    updatePriceDineIn(){
      this.priceDineIn = ItemUtil.getPriceWithoutVat(this.vat.dineIn, this.priceDineInWithVat);
    },
    applyDineInPriceSuggestion(){
      this.priceDineIn = Number(this.price);
      this.updatePriceDineInWithVat();
    },
    saveAddOn(){
      this.loading = true;

      this.addOn.price = this.price;
      this.addOn.priceDineIn = this.priceDineIn;

      let addOn = Object.assign({}, this.addOn);
      if(!addOn.templateId){
        delete addOn.templateId;
      }
      if(!addOn.itemId){
        delete addOn.itemId;
      }
      this.createAddOn(addOn);
    },
    createAddOn(addOn){
      console.log('addOn: ' + JSON.stringify(addOn));
      ProductService.createAddOn(addOn).then(
          (response) => {
            let documentId = response.data;
            if(documentId){
              if(this.panelMode){ this.$emit('saved'); } else { this.$router.push({ path: 'products'}); }
            } else {
              console.log("Creating addOn failed");
            }
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    }
  }
};
</script>
